import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ILogoutService } from '@app/shared/auth/logout/logout-service';
import { LOGOUT } from '@app/shared/auth/logout/logout.token';
import { MenuUserButtonItem } from '../menu-user-button-item';

@Component({
  selector: 'app-logout-menu-item',
  imports: [MenuUserButtonItem, MatIcon],
  templateUrl: './logout-menu-item.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './logout-menu-item.scss',
})
export class LogoutMenuItem {
  private logoutService = inject<ILogoutService>(LOGOUT);
  logout() {
    this.logoutService.logout();
  }
}
